<template>
    <section class="section section--intro">
        <Heading text="Kým jsme" />
        <h2>Pomáháme lidem poznat sebe sama a tím nacházet své místo v životě.</h2>
        <p class="section__text">Jsme průvodci na cestě k rozvoji kompetencí<br /> potřebných k dosažení <transition name="fade-in-out" mode="out-in"><strong :key="goals[0]">{{ goals[0] }}</strong></transition></p>
    </section>
</template>

<script>
    import Heading from './includes/Heading.vue'; 

    export default {
        name: 'Intro',
        components: {
            Heading
        },
        data() {
            return {
                goals: ['spokojeného života', 'zdravých vztahů', 'rovnováhy', 'fungující firmy', 'úspěchu', 'lepších výsledků', 'zdraví', 'vysněných cílů']
            }
        },
        mounted() {
            window.setInterval(() => {
                this.pollGoal();
            }, 2000)
        },
        methods: {
            pollGoal() {
                const first = this.goals.shift();
                this.goals = this.goals.concat(first);
            }
        }
    }
</script>

<style lang="scss" scoped>
    
    .section {

        &__text {
            margin: 0;
            line-height: 1.5;
            text-align: center;
            font-size: 2.2rem;
            font-weight: 300;
            color: #888;

            strong {
                font-weight: 500;
                color: #385dae;
            }
        }

        h2 {
            text-align: center;
        }

        &--intro {
            background-color: #f3f5f8;
        }
    }

    @media (max-width: 767px) {

        .section {

            h2 {
                line-height: 1.6;
                font-size: 20px;
            }

            &__text {
                font-size: 1.7rem;
            }
        }
    }

</style>
